import React from 'react'
import styles from "../css/MobileHeader.module.css"
import LogoItem from '../../Logo/LogoItem'

const MobileHeader = ({title,subtitle}) => {
        
    return (
        <div className={styles.hero}>
            <div className={`${styles.heroBlob} ${styles.blob1}`}></div>
            <div className={`${styles.heroBlob} ${styles.blob2}`}></div>
            <div className={styles.heroContent}>
                <LogoItem theme = "dark"/>
                <h2 className={styles.title}>{title}</h2>
                <p className={styles.subtitle}>{subtitle}</p>
            </div>
        </div>
  )
}

export default MobileHeader